import * as topojson from 'topojson-client';
export { topojson as default };
